export interface ClaimNode {
    integerNum: number;
    preamble: {
        text: string;
    };
    transitional: {
        text: string;
    };
    body: {
        text: string;
        elements: {
            desc: string;
            attribute?: string;
        }[];
    };
    num: string;
    wholeText: string;
    parentNums?: string[];
}

export interface PatentClaimsTreeResponse {
    claims: {
        CLMS_TREE: ClaimNode[];
        PN: string;
    };
}
export interface PatentClaimApi {
    /**
     * 获取专利权利要求
     */
    getPatentClaim(payload: {patentId: string ,lang: string}): Promise<string>;
    /**
     * 获取专利权利要求树
     * @param patentId 专利id
     * @returns 权利要求树数据
     */
    getPatentClaimsTree: (patentId: string) => Promise<PatentClaimsTreeResponse>;
}

export const PatentClaimApi = Symbol.for('PatentClaimApi');
